import { APIHelper } from '@archistarai/auth-frontend';
import { findByKey, filterByKey } from 'vuex-intern';

export default {
  state: {
    roles: [
      { id: 2001, name: 'Company Admin', shortName: 'CompanyAdmin', isSystemUser: 0 },
      { id: 2002, name: 'Location Admin', shortName: 'LocationAdmin', isSystemUser: 0 },
      { id: 2003, name: 'Standard User', shortName: 'StandardUser', isSystemUser: 0 },
      { id: 2004, name: 'Member (Free)', shortName: 'MemberUser', isSystemUser: 0 },
      { id: 1006, name: 'Sales User', shortName: 'SalesUser', isSystemUser: 1 },
      { id: 1005, name: 'Sales Manager', shortName: 'SalesManager', isSystemUser: 1 },
      { id: 1004, name: 'Customer Success', shortName: 'CustomerSuccess', isSystemUser: 1 },
      { id: 1000, name: 'Super Admin', shortName: 'SuperAdmin', isSystemUser: 1 },
      { id: 1007, name: 'FinanceUser', shortName: 'FinanceUser', isSystemUser: 1 },
      { id: 1003, name: 'Design Admin', shortName: 'DesignAdmin', isSystemUser: 1 },
      { id: 1002, name: 'Data Admin', shortName: 'DataAdmin', isSystemUser: 1 },
      { id: 1001, name: 'System Admin', shortName: 'SystemAdmin', isSystemUser: 1 },
      { id: 1013, name: 'Document Admin', shortName: 'DocumentAdmin', isSystemUser: 1 }
    ]
  },
  getters: {
    get: (state) => (name) => {
      return state.roles.find((u) => u.shortName === name);
    },
    whereRoleId: findByKey('roles', 'id'),
    whereSystemUser: filterByKey('roles', 'isSystemUser')
  },
  mutations: {},
  actions: {
    async getUserRoles({ _commit }, userGuid) {
      try {
        const { data } = await APIHelper.AdminAPI.get(`/users/${userGuid}/roles`);
        return data.data;
      } catch (e) {
        throw e;
      }
    },
    async getUserCompanyRoles({ _commit }, { userGuid, companyGuid }) {
      try {
        const { data } = await APIHelper.AdminAPI.get(`/users/${userGuid}/companies/${companyGuid}/roles`);
        return data.data;
      } catch (e) {
        throw e;
      }
    },
    async deleteUserRole({ _commit }, id) {
      try {
        const { data } = await APIHelper.AdminAPI.delete(`/user-roles/${id}`);
        return data.data;
      } catch (e) {
        throw e;
      }
    },
    async putUserCompanyRole({ _commit }, { userGuid, companyGuid, roleId, locationGuid }) {
      try {
        const { data } = await APIHelper.AdminAPI.put(`/users/${userGuid}/companies/${companyGuid}/roles`, {
          role_id: roleId,
          location_guid: locationGuid
        });
        return data.data;
      } catch (e) {
        throw e;
      }
    }
  }
};
